import { useTranslation } from "next-i18next";
import { useAppContext } from "@/src/config/AppProvider";
import ContactFormSection from "./sections/ContactFormSection/ContactFormSection";
import ContactSection from "./sections/ContactSection/ContactSection";
import MapSection from "@/src/features/contact-us/sections/MapSection/MapSection";

const ContactUsPage = () => {
  const { t } = useTranslation();
  const { licenceSettings } = useAppContext();

  return (
    <>
      <div className="rbt-conatct-area bg-gradient-11 rbt-section-gap2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center mb--60">
                <span className="subtitle bg-secondary-opacity">{t("contactInformation")}</span>
                <h2 className="title">{t("contactDescription")}</h2>
              </div>
            </div>
          </div>
          <ContactSection />
        </div>
      </div>
      <ContactFormSection />
      <div className="rbt-google-map bg-color-white rbt-section-gapTop">
        <MapSection x={licenceSettings.Latitude} y={licenceSettings.Longitude} companyTitle={licenceSettings.SiteTitle} />
      </div>
    </>
  );
};

export default ContactUsPage;
